var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewindForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2571_890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6149 28.7477C17.7837 33.579 9.95067 33.579 5.11943 28.7477C0.288177 23.9165 0.288177 16.0835 5.11943 11.2523C9.95067 6.421 17.7837 6.421 22.6149 11.2523C25.0321 13.6694 26.2399 16.838 26.2384 20.0061L26.2384 22.7492",
    stroke: "#F1F7FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4664 20.9641L26.2035 23.227L23.9406 20.9641",
    stroke: "#F1F7FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2571_890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewindForward);
export default __webpack_public_path__ + "static/media/RewindForward.0b1e473a19ac4886587fca5d74b25c56.svg";
export { ForwardRef as ReactComponent };